import {useMessages} from "i18n";

/**
 * Advertising Terms content (kitecorp/transferify-ui#2602). Thin wrapper that renders the active
 * locale's title-free body from the catalog (`messages.legal.advertisingTerms`, defined in
 * `src/i18n/advertisingTerms.<locale>.tsx`), exactly as its siblings in this directory do. The owning
 * route supplies the single document title.
 *
 * No dialog surface, like {@link ./Impressum}: the Resources row and the footer navigate to
 * `/advertising-terms`, and the booking form and the pay step link the same address, so an advertiser
 * can save or print the version they contracted under (§ 312i Abs. 1 Nr. 4 BGB).
 */
export default function AdvertisingTerms() {
	return useMessages().legal.advertisingTerms();
}
